import React from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import './job-validations.styles.less'

import { ValidationCard } from './validation-card.component'

const JobValidations = ({ job }) => {
  const { t } = useTranslation()
  const translationPath = 'jobs.job.info.data-validation'

  const titles = {
    AGE: {
      title: t(`${translationPath}.age`),
      photoViewerTitle: t(`${translationPath}.photo-viewer.age-verification`),
      photoName: t(`${translationPath}.photo-age`)
    },
    MEDICINE_PRESCRIPTION: {
      title: t(`${translationPath}.medical-order`),
      photoViewerTitle: t(`${translationPath}.photo-viewer.medical-order-verification`),
      photoName: t(`${translationPath}.photo-medical-order`)
    },
    Others: {
      title: t(`${translationPath}.others`),
      photoViewerTitle: t(`${translationPath}.photo-viewer.others-verification`),
      photoName: t(`${translationPath}.photo-others`)
    }
  }

  return (
    <>
      {job.deliveryCode && (
        <Alert message={t(`${translationPath}.alert-message`)} type='info' showIcon icon={<InfoCircleOutlined />} />
      )}
      <section className='validation-container'>
        {job.deliveryValidations?.map((validation) => {
          const titleInfo = titles[validation.type] ?? titles.Others
          return (
            <ValidationCard
              photo={validation.photoUrl}
              photoName={titleInfo.photoName}
              title={titleInfo.title}
              photoViewerTitle={titleInfo.photoViewerTitle}
              job={job}
              key={validation.type}
              imageType={validation.type}
            />
          )
        })}
        {job.pickupCode && <ValidationCard pickupCode={job.pickupCode} title={t(`${translationPath}.pickup-code`)} />}
        {job.deliveryOptions?.map((option) => {
          return option.method === 'CONTACT_LESS' ? (
            <ValidationCard
              photo={option.photoUrl}
              photoName={t(`${translationPath}.photo-delivery`)}
              title={t(`${translationPath}.delivery`)}
              photoViewerTitle={t(`${translationPath}.photo-viewer.delivery-verification`)}
              job={job}
              detail={{
                cash_receiver: option.cashReceiver,
                phone_number: option.phoneNumber,
                comment: option.comment
              }}
              imageType={option.method}
            />
          ) : null
        })}
      </section>
    </>
  )
}

export { JobValidations }
